import React, {Fragment} from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import {Card, CardBody, Col, Row} from "reactstrap";
import PageHeading from "Layout/AppMain/PageHeading";
import PushMessagesTable from "./PushMessagesTable";


const PushMessagesDefault = () => {
    
    return (
        <Fragment>
           <div className="d-flex justify-content-between align-items-center">
                <PageHeading/>
            
            </div>
            <TransitionOnLoad>
                    <div>
                     
                        <Row>
                            <Col md="12">
                                <Card className="main-card mb-3">
                                    <CardBody className="p-3">
                                        <PushMessagesTable/>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </TransitionOnLoad>
        </Fragment>
    )
};

export default PushMessagesDefault;
